export default "__VITE_ASSET__BNgwFUWA__"